import AlertIcon from '@service-victoria/component-library/components/Icons/Alert';
import CircleTick from '@service-victoria/component-library/components/Icons/CircleTick';
import colors from '@service-victoria/component-library/utils/colors';
import styled from 'styled-components';

import { InlineNotificationProps } from './InlineNotification';

export const Wrapper = styled.div<Partial<InlineNotificationProps>>`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  width: 100%;
  max-width: 485px;
  background-color: ${({ type }) => (type === 'success' ? colors.green15 : colors.orange25)};
  box-shadow: 0 2px 4px -2px rgba(0, 0, 0, 0.8), 0 4px 6px 2px rgba(0, 0, 0, 0.15);
  border-radius: 8px;
  user-select: none;
`;

const sharedIconStyles = `
  width: 24px;
  height: 24px;
  margin-right: 16px;
`;

export const SuccessIcon = styled(CircleTick).attrs({
  fill: colors.green
})`
  ${sharedIconStyles}
`;

export const ErrorIcon = styled(AlertIcon).attrs({
  fill: colors.red
})`
  ${sharedIconStyles}
`;

export const ContentWrap = styled.div`
  display: flex;
`;

export const Content = styled.div`
  font-size: 18px;
  font-weight: bold;
  margin: 0;
  color: ${colors.blueGrey};
`;
